import { Subscription } from 'rxjs';
import { Component, OnInit, forwardRef, Input, OnDestroy } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormEditorBase } from './../../../../../models/forms/formEditor.base';
import { FormFieldOptions } from './../../../../..//models/forms/formField.model';
import { FormControlService } from './../../../../../shared/services/form-control.service';
import { DragulaService } from 'ng2-dragula';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ContainedFieldsComponent),
  multi: true
};

@Component({
  selector: 'swb-contained-fields',
  templateUrl: './contained-fields.component.html',
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class ContainedFieldsComponent extends FormEditorBase implements OnInit, OnDestroy {
  private _onModelChanged: Function;
  private _subscription: Subscription;

  public value: any;

  public fieldOptions = FormFieldOptions.options;

  @Input()
  public lang: string;

  constructor(
    private _dragulaService: DragulaService,
    private _formService: FormControlService
  ) {
    super();
  }

  public ngOnInit(): void {
    this._dragulaService.dropModel().subscribe((dragula: any) => {
      dragula.targetModel.forEach((item: any, order: number) => {
        item.position = order;
      });
      this._onModelChanged(dragula.targetModel);
    });
  }

  public ngOnDestroy(): void {
    if (this._dragulaService.find('formfields-' + this.lang) !== undefined) { this._dragulaService.destroy('formfields-' + this.lang); }
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }

  public registerOnChange(fn: Function): void {
    this._onModelChanged = fn;
  }

  public registerOnTouched(fn: Function): void {
    // noop
  }

  public writeValue(value: any) {
    this.value = value;
  }

  public removeField(i: number): void {
    this.value.splice(i, 1);
    this._onModelChanged(this.value);
  }

  public addField(lang: string): void {
    const newEntity = this._formService.getFormFieldsModel(lang, this.value.length);
    this.value.push(newEntity);
  }

}
